import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListJenisTinggal } from "@/services/getData"

export default function MasterJenisTinggal() {
  const { data, isPending } = useQuery({
    queryKey: ["listJenisTinggal"],
    queryFn: getListJenisTinggal,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
